import { isCookieSet, setCookie } from './cookies'

const attributionCookieName = 'landing'

export function isAttributionCookieSet() {
  return isCookieSet(attributionCookieName)
}

export function setAttributionCookie() {
  const ref = document.referrer
  const url = window.location.href
  const today = new Date().toISOString().slice(0, 10)

  setCookie(attributionCookieName, url + '|' + ref + '|' + today)
}
